import { z } from 'zod';

export const promoteAppVersionFromDraftToProductionSchema = z.object({
  fullVersion: z.string(),
});

export const commitComponentOverrideSchema = z.object({
  nextMajor: z.string(),
  nextMinor: z.string().optional(),
});

export const createAppReleaseSchema = z.object({
  tag: z.string(),
});

export const releaseSchema = z.object({
  releaseBaseUrl: z.string(),
});
